import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { formatCAD } from "@/lib/format";
import SafeImage from "@/components/SafeImage";

export default function ProductCard({ product, className = "" }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.product_id}`}
      className={`group block surface overflow-hidden ${className}`}
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#F3F2F0]">
        <SafeImage
          src={product.featured_image || product.images?.[0]}
          alt={product.name}
          className="product-card-img w-full h-full object-cover"
        />
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading text-lg leading-tight text-[#1A1A18] line-clamp-2">{product.name}</h3>
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="font-mono text-sm text-[#1A1A18]">{formatCAD(product.price)}</div>
          <div className="flex items-center gap-1 text-xs text-[#5C5A56]">
            <Star className="w-3.5 h-3.5 fill-[#C78B1B] text-[#C78B1B]" strokeWidth={1.5} />
            <span>{product.rating?.toFixed(1)}</span>
            <span className="text-[#8A8782]">({product.review_count})</span>
          </div>
        </div>
        {product.product_type !== "STANDARD" && (
          <span className="tag-pill mt-3 inline-flex bg-[#E5EBE8] text-[#2A4B3A]">
            {product.product_type === "POD" ? "Print on Demand" : "Customizable"}
          </span>
        )}
      </div>
    </Link>
  );
}
